import { useEffect, useState } from "react";
import { Assessment } from "../../../../models/assessments";
import { Box, Button, Typography } from "@mui/material";

interface TimerViewProps {
    assessment: Assessment;
    onTimeExpired: () => Promise<void>;
    started: boolean;
}

export default function TimerView({ assessment, onTimeExpired, started }: TimerViewProps) {
    const [timeLeft, setTimeLeft] = useState<number | null>(null);
    const [hasExpired, setHasExpired] = useState(false);

    function formatTime(seconds: number) {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }

    const forceSubmit = async () => {
        await onTimeExpired();
    }

    useEffect(() => {
        if (timeLeft !== null || assessment.duration < 0 || hasExpired) return;

        let initialTimeLeft = assessment.duration * 60;

        if (assessment.started_at && !assessment.submitted) {
            const startTime = new Date(assessment.started_at).getTime();
            const now = Date.now();
            const durationMs = assessment.duration * 60 * 1000;
            const timePassed = now - startTime;
            initialTimeLeft = Math.max(0, Math.floor((durationMs - timePassed) / 1000));
        }

        setTimeLeft(initialTimeLeft);
        
    }, [assessment]);

    useEffect(() => {
        if (!timeLeft || !started || timeLeft <= 0) return;

        const interval = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev === null) return prev;

                if (prev <= 1) {
                    clearInterval(interval);
                    setHasExpired(true);
                    forceSubmit();
                    return 0;
                }

                return prev - 1;
            });

        }, 1000);

        return () => clearInterval(interval);
    
    }, [timeLeft, started]);


    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "rgba(255,255,255,0.1)",
                padding: "6px 12px",
                margin: 2,
                borderRadius: 2,
                flexShrink: 0,
            }}
        >
            <Typography
                sx={{
                    fontWeight: 600,
                    color: "white",
                    fontSize: "1rem",
                }}
            >
                ⏱ {timeLeft !== null ? formatTime(timeLeft) : "--:--"}
            </Typography>

        </Box>
    );
}
